export default "__VITE_ASSET__DUR53uXN__"